import { FC, PropsWithChildren } from "react";
import "./BaseText.scss";

interface IBaseTextProps extends PropsWithChildren {
    /**
     * Render as 'div' instead of paragraph
     */
    asDiv?: boolean;
    /**
     * Big sized paragraph
     */
    large?: boolean;
    /**
     * Medium sized paragraph
     */
    medium?: boolean;
    /**
     * Class name for custom styling
     */
    classNames?: string[];
}

export const BaseText: FC<IBaseTextProps> = ({ asDiv, large, medium, classNames = [], children }) => {
    const _classNames: string[] = classNames;
    if (large) _classNames.push("p-large");
    if (medium) _classNames.push("p-medium");
    const className = _classNames.join(" ");

    if (asDiv) {
        return <div className={className}>{children}</div>;
    } else {
        return <p className={className}>{children}</p>;
    }
};
